import React, { useEffect, useRef, useState } from "react";

const StatusPatientChange = ({ options, row, initialValue, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialValue);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);
  const isOptionDisabled = (option) => {
    return (
      row?.statusName === "Scheduled Screen" &&
      option.statusName === "Scheduled Screen"
    );
  };

  useEffect(() => {
    setSelectedOption(initialValue);
  }, [initialValue]);

  useEffect(() => {
    setFilteredOptions(
      options.filter((option) =>
        option.statusName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, options]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option.statusName); // Update the button text
    setIsOpen(false); // Close the dropdown
    onSelect(option); // Trigger the onSelect callback with the selected option
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.style.setProperty(
        "border",
        "1px solid #245cea",
        "important"
      );
    }
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="px-5 py-1 rounded-full border secondary_btn transition-all duration-500"
        ref={buttonRef}
      >
        {selectedOption}
      </button>

      {isOpen && (
        <div className="fixed top-[250px] z-30 p-2 mt-2 bg-white rounded shadow-md w-[250px] border light_border_color">
          <div className="flex items-center border rounded-lg p-2 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 text-black-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.35 4.35a7.5 7.5 0 0012.3 12.3z"
              />
            </svg>
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search..."
              className="w-full outline-none ml-2 text-sm"
            />
          </div>
          <ul className={`max-h-[400px] overflow-y-auto`}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => {
                const isDisabled = isOptionDisabled(option);

                return (
                  <li
                    key={option.statusID}
                    onClick={() => {
                      if (isDisabled) return; // 🚫 block click
                      handleOptionClick(option);
                    }}
                    className={`
          px-4 py-2
          ${
            isDisabled
              ? "text-[#87909E] cursor-not-allowed bg-[#F0F1F3]"
              : "hover:bg-[[#F0F1F3]] cursor-pointer"
          }
        `}
                    title={isDisabled ? "Already scheduled" : ""}
                  >
                    <span className="hidden">{option.normalizedStatus}</span>
                    {option.statusName}
                  </li>
                );
              })
            ) : (
              <li className="px-4 py-2 text-gray-500">No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StatusPatientChange;
